
import { Prop, Vue, Component } from "vue-property-decorator";
import { CustomFieldDto,CustomFieldExtendedDataSupportedTypes, CustomFieldExtendedDataTypes } from "@/store/custom-fields/types";
import vSelect3 from "vselect3";
import CustomFieldModalUpdateViewExtendedDataActionPlanResult from "./CustomFieldModalUpdateViewExtendedDataActionPlanResult.vue";

@Component({
	components: {
		"v-select-3": vSelect3,
		CustomFieldModalUpdateViewExtendedDataActionPlanResult
	}
})
export default class CustomFieldModalUpdateViewExtendedData extends Vue {
	@Prop({ required: true }) public customField: CustomFieldDto;

	private extendedDataType: CustomFieldExtendedDataTypes | null = null;
	protected currentComponent: string | null = null;

	private mounted(): void {
		this.loadComponent();
	}

	/**
	 * Dynamically loads the component based on the custom field type and supported options.
	 * @param customField The custom field data to determine the component to load.
	 */
	private async loadComponent(): Promise<void> {
		// check if the custom field type is supported for extended data.
		if (CustomFieldExtendedDataSupportedTypes.includes(this.customField.customFieldTypeId)) {
			if (this.customField.options.dataFromActionPlans) {
				this.extendedDataType = CustomFieldExtendedDataTypes.ActionPlanResult;
				this.currentComponent = this.getComponentName;
			}
		}
	}

	private get getComponentName(): string {
		return `CustomFieldModalUpdateViewExtendedData${this.extendedDataType}`;
	}

	private get isExtendedDataForActionPlans(): boolean {
		if (CustomFieldExtendedDataSupportedTypes.includes(this.customField.customFieldTypeId)) {
			if (this.customField.options.dataFromActionPlans) {
				return true;
			}
		}
		return false;
	}

	private get dataFromActionPlans(): boolean {
		return !!this.customField.options.dataFromActionPlans;
	}

	private set dataFromActionPlans(value: boolean) {
		if (value) {
			// Create an object with default values when checkbox is checked
			Vue.set(this.customField.options, 'dataFromActionPlans', {
				labelIds: [],
				includeTaskTitle: false
			});
		} else {
			// Set to null when checkbox is unchecked
			Vue.set(this.customField.options, 'dataFromActionPlans', null);
		}
		this.loadComponent();
	}
}
